import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {WorkOrderService} from '../../../../Services/work-order.service';
import {BsToastService} from '../../../../Services/bs-toast-service';
import {ConfirmDialogService} from '../../../../Services/confirm-dialog.service';
import {DataService} from '../../../../Services/data.service';

@Component({
  selector: 'app-asset-form',
  templateUrl: './asset-form.component.html',
  standalone: false,
})
export class AssetFormComponent implements OnInit {

  assetId: string | null = null;
  isLoaded = false;
  saving = false;
  form: UntypedFormGroup;
  entities: any[] = [];
  locations: any[] = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: UntypedFormBuilder,
    private woService: WorkOrderService,
    private dataService: DataService,
    private notification: BsToastService,
    public confirmDialog: ConfirmDialogService,
  ) {
    this.form = this.fb.group({
      entity_id: [null, Validators.required],
      location_id: [null],
      name: ['', Validators.required],
      asset_tag: [''],
      serial_number: [''],
      model: [''],
      manufacturer: [''],
      install_date: [null],
      warranty_expiry: [null],
      last_service_date: [null],
      next_service_date: [null],
      notes: [''],
      active: [true],
    });
  }

  ngOnInit(): void {
    this.assetId = this.route.snapshot.queryParamMap.get('id');
    this.dataService.getDataWithParams('entity', 'pageNumber=0&pageSize=999999').subscribe({
      next: (r: any) => this.entities = r?.Data ?? r?.data ?? r ?? [],
      error: () => {
      }
    });
    this.dataService.getDataWithParams('location', 'pageNumber=0&pageSize=999999').subscribe({
      next: (r: any) => this.locations = r?.Data ?? r?.data ?? r ?? [],
      error: () => {
      }
    });
    if (this.assetId) {
      this.woService.getAsset(this.assetId).subscribe({
        next: (res) => {
          this.form.patchValue(res);
          this.isLoaded = true;
        },
        error: () => {
          this.notification.showErrorToast('Error loading asset.');
          this.isLoaded = true;
        }
      });
    } else {
      this.isLoaded = true;
    }
  }

  save(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.saving = true;
    const body = this.form.getRawValue();
    const obs = this.assetId
      ? this.woService.updateAsset(this.assetId, body)
      : this.woService.createAsset(body);
    obs.subscribe({
      next: () => {
        this.notification.showSuccessToast('Asset saved.');
        this.saving = false;
        this.router.navigate(['/work-orders/assets/asset-list']);
      },
      error: () => {
        this.notification.showErrorToast('Error saving asset.');
        this.saving = false;
      }
    });
  }

  cancel(): void {
    this.router.navigate(['/work-orders/assets/asset-list']);
  }
}
